// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/franklin/api/instrument.proto (package squareup.franklin.api, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { LocalizableString } from "../../cash/localization/localization_pb";
import { file_squareup_cash_localization_localization } from "../../cash/localization/localization_pb";
import type { Money } from "../../common/currency_pb";
import { file_squareup_common_currency } from "../../common/currency_pb";
import type { InstrumentType } from "../../common/instrument_pb";
import { file_squareup_common_instrument } from "../../common/instrument_pb";
import { file_squareup_common_pii } from "../../common/pii_pb";
import type { CashInstrumentType } from "../cash_instrument_type_pb";
import { file_squareup_franklin_cash_instrument_type } from "../cash_instrument_type_pb";
import { file_squareup_objc_objc } from "../../objc/objc_pb";
import type { ApplePayPaymentToken, GooglePayPaymentToken } from "../digital_wallet_pb";
import { file_squareup_franklin_digital_wallet } from "../digital_wallet_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file squareup/franklin/api/instrument.proto.
 */
export const file_squareup_franklin_api_instrument: GenFile = /*@__PURE__*/
  fileDesc("CiZzcXVhcmV1cC9mcmFua2xpbi9hcGkvaW5zdHJ1bWVudC5wcm90bxIVc3F1YXJldXAuZnJhbmtsaW4uYXBpIp0KCgpJbnN0cnVtZW50Eg0KBXRva2VuGAEgASgJEkMKFGNhc2hfaW5zdHJ1bWVudF90eXBlGAIgASgOMiUuc3F1YXJldXAuZnJhbmtsaW4uQ2FzaEluc3RydW1lbnRUeXBlEj4KCmNhcmRfYnJhbmQYAyABKA4yKi5zcXVhcmV1cC5jb21tb24uaW5zdHJ1bWVudC5JbnN0cnVtZW50VHlwZRIOCgZzdWZmaXgYBCABKAkSFwoJYmFua19uYW1lGAUgASgJQgTA6woBEhAKCGljb25fdXJsGAYgASgJEhcKD2RldGFpbF9pY29uX3VybBgKIAEoCRIxChFhdmFpbGFibGVfYmFsYW5jZRgHIAEoCzIWLnNxdWFyZXVwLmNvbW1vbi5Nb25leRIPCgd2ZXJzaW9uGAggASgDEhQKDGRpc3BsYXlfbmFtZRgLIAEoCRJhChhsb2NhbGl6YWJsZV9kaXNwbGF5X25hbWUYFCABKAsyLS5zcXVhcmV1cC5jYXNoLmxvY2FsaXphdGlvbi5Mb2NhbGl6YWJsZVN0cmluZ0IQ4vYZDGRpc3BsYXlfbmFtZRIdCg9iYW5rX3Nob3J0X25hbWUYDCABKAlCBMDrCgESFgoOd2FsbGV0X2FkZHJlc3MYDSABKAkSDgoGc3ltYm9sGA4gASgJEhwKFHBlbmRpbmdfdmVyaWZpY2F0aW9uGA8gASgIEhoKEnNlbGVjdGlvbl9pY29uX3VybBgQIAEoCRIYChBzdXBwb3J0c19jYXNoX2luGBEgASgIEhkKEXN1cHBvcnRzX2Nhc2hfb3V0GBIgASgIEhMKC29jY3VycmVkX2F0GBMgASgDEhgKEGNhcmRfdGhlbWVfdG9rZW4YFSABKAkSDgoGcHJlZml4GBYgASgJEk4KF2FwcGxlX3BheV9wYXltZW50X3Rva2VuGBcgASgLMisuc3F1YXJldXAuZnJhbmtsaW4uYXBpLkFwcGxlUGF5UGF5bWVudFRva2VuSAASUAoYZ29vZ2xlX3BheV9wYXltZW50X3Rva2VuGBggASgLMiwuc3F1YXJldXAuZnJhbmtsaW4uYXBpLkdvb2dsZVBheVBheW1lbnRUb2tlbkgAEiEKGXBheW1lbnRfYWNjb3VudF9yZWZlcmVuY2UYGSABKAkSJwobZGVmYXVsdF9mb3JfaW5zdHJ1bWVudF90eXBlGBogASgIQgIYARIZChFhY2Nlc3NvcnlfaWNvbl9pZBgbIAEoCRIWCg5hY2Nlc3NvcnlfdGV4dBgcIAEoCRJlChpsb2NhbGl6YWJsZV9hY2Nlc3NvcnlfdGV4dBggIAEoCzItLnNxdWFyZXVwLmNhc2gubG9jYWxpemF0aW9uLkxvY2FsaXphYmxlU3RyaW5nQhLi9hkOYWNjZXNzb3J5X3RleHQSHAoUZGlzcGxheV9uYW1lX2NvbXBhY3QYHSABKAkScQogbG9jYWxpemFibGVfZGlzcGxheV9uYW1lX2NvbXBhY3QYISABKAsyLS5zcXVhcmV1cC5jYXNoLmxvY2FsaXphdGlvbi5Mb2NhbGl6YWJsZVN0cmluZ0IY4vYZFGRpc3BsYXlfbmFtZV9jb21wYWN0EiYKHmlzX2RlZmF1bHRfZm9yX2luc3RydW1lbnRfdHlwZRgeIAEoCBIUCgxjYXJkX2FydF91cmwYHyABKAlCHgocZGlnaXRhbF93YWxsZXRfcGF5bWVudF90b2tlbkJHCiBjb20uc3F1YXJldXAucHJvdG9zLmZyYW5rbGluLmFwaVoVc3F1YXJldXBfZnJhbmtsaW5fYXBpwpsDCkNDQVBJUHJvdG8", [file_squareup_cash_localization_localization, file_squareup_common_currency, file_squareup_common_instrument, file_squareup_common_pii, file_squareup_franklin_cash_instrument_type, file_squareup_objc_objc, file_squareup_franklin_digital_wallet]);

/**
 * @generated from message squareup.franklin.api.Instrument
 */
export type Instrument = Message<"squareup.franklin.api.Instrument"> & {
  /**
   * * A token identifying the instrument. 
   *
   * @generated from field: optional string token = 1;
   */
  token: string;

  /**
   * * The type of instrument, such as a debit card or bank account. 
   *
   * @generated from field: optional squareup.franklin.CashInstrumentType cash_instrument_type = 2;
   */
  cashInstrumentType: CashInstrumentType;

  /**
   * *
   * The brand of the card, such as Visa or Mastercard. Only populated for card
   * instruments.
   *
   * @generated from field: optional squareup.common.instrument.InstrumentType card_brand = 3;
   */
  cardBrand: InstrumentType;

  /**
   * *
   * A suffix of the instrument that is suitable for display. Such as the last four
   * numbers of a card or the last three numbers of a bank account.
   *
   * @generated from field: optional string suffix = 4;
   */
  suffix: string;

  /**
   * * The name of the bank that issued the instrument. 
   *
   * @generated from field: optional string bank_name = 5;
   */
  bankName: string;

  /**
   * *
   * The URL of the icon to use when displaying the instrument in a list. The icon might be the
   * logo of a specific bank or a generic icon. At present, these are black and white icons.
   *
   * @generated from field: optional string icon_url = 6;
   */
  iconUrl: string;

  /**
   * *
   * The URL of the icon to use when displaying the instrument on a details page. The icon might
   * be the logo of a specific bank or a generic icon. At present, these are color icons.
   *
   * @generated from field: optional string detail_icon_url = 10;
   */
  detailIconUrl: string;

  /**
   * *
   * The balance available in the instrument. For now this is only used with Cash Balances.
   *
   * @generated from field: optional squareup.common.Money available_balance = 7;
   */
  availableBalance?: Money;

  /**
   * *
   * The version of this instrument for asynchronous updates.
   *
   * @generated from field: optional int64 version = 8;
   */
  version: bigint;

  /**
   * * The name to display for the instrument. Examples: "Checking 123" and "Debit Card 1234". 
   *
   * @generated from field: optional string display_name = 11;
   */
  displayName: string;

  /**
   * @generated from field: optional squareup.cash.localization.LocalizableString localizable_display_name = 20;
   */
  localizableDisplayName?: LocalizableString;

  /**
   * * A short variation of the name of the bank that issued the instrument. 
   *
   * @generated from field: optional string bank_short_name = 12;
   */
  bankShortName: string;

  /**
   * * The wallet address in case it is a BTC cash balance instrument. 
   *
   * @generated from field: optional string wallet_address = 13;
   */
  walletAddress: string;

  /**
   * * The symbol of the equity in case it is an equity instrument. 
   *
   * @generated from field: optional string symbol = 14;
   */
  symbol: string;

  /**
   * *
   * Determines if the instrument is in the process of being verified.
   * Unverified instruments should not be usable but should be displayed in the client.
   *
   * @generated from field: optional bool pending_verification = 15;
   */
  pendingVerification: boolean;

  /**
   * *
   * The URL of the icon to use when displaying the instrument selector in a payment flow.
   * The icon might be the logo of a specific bank or a generic icon.
   *
   * @generated from field: optional string selection_icon_url = 16;
   */
  selectionIconUrl: string;

  /**
   * *
   * Determines whether the instrument supports cash in or not. This information is going to be
   * used to construct or to replace TransferInstrumentMap.
   *
   * @generated from field: optional bool supports_cash_in = 17;
   */
  supportsCashIn: boolean;

  /**
   * *
   * Determines whether the instrument supports cash out or not. This information is going to be
   * used to construct or to replace TransferInstrumentMap.
   *
   * @generated from field: optional bool supports_cash_out = 18;
   */
  supportsCashOut: boolean;

  /**
   * *
   * Timestamp representing when InstrumentLink attempt occurred at. This will help to identify
   * customer's oldest linked instrument.
   *
   * @generated from field: optional int64 occurred_at = 19;
   */
  occurredAt: bigint;

  /**
   * *
   * The opaque token representing the theme of the card. Example themes include pink and glitter.
   * Only populated for cash card instruments.
   *
   * @generated from field: optional string card_theme_token = 21;
   */
  cardThemeToken: string;

  /**
   * *
   * The prefix of an instrument that is suitable for display. It can also be used for business logic
   * i.e. the BIN of a card
   *
   * @generated from field: optional string prefix = 22;
   */
  prefix: string;

  /**
   * *
   * An instrument can be also represented as a single use payment as well. If cash_instrument_type
   * were of the digital wallet variety, this should be populated
   *
   * @generated from oneof squareup.franklin.api.Instrument.digital_wallet_payment_token
   */
  digitalWalletPaymentToken: {
    /**
     * @generated from field: squareup.franklin.api.ApplePayPaymentToken apple_pay_payment_token = 23;
     */
    value: ApplePayPaymentToken;
    case: "applePayPaymentToken";
  } | {
    /**
     * @generated from field: squareup.franklin.api.GooglePayPaymentToken google_pay_payment_token = 24;
     */
    value: GooglePayPaymentToken;
    case: "googlePayPaymentToken";
  } | { case: undefined; value?: undefined };

  /**
   * *
   * The identifier of the backing account for all card / digital wallet / network token transactions
   * This identifier is received at network token provisioning time or after authorization of both
   * card and digital wallet transactions.
   *
   * @generated from field: optional string payment_account_reference = 25;
   */
  paymentAccountReference: string;

  /**
   * *
   * Deprecated: not controlled by multi-linking amplitude rollout flag.
   * please use is_default_for_instrument_type instead.
   * Whether this is the default instrument of this type for the user 
   *
   * @generated from field: optional bool default_for_instrument_type = 26 [deprecated = true];
   * @deprecated
   */
  defaultForInstrumentType: boolean;

  /**
   * * 
   * Powers the sub-icon on the instrument in Linked Banks, which shows up as a small badge.
   * Is an Arcade icon_id (go/arcadeicons) e.g. "W9jg3z" for the star icon to indicate a default 
   *
   * @generated from field: optional string accessory_icon_id = 27;
   */
  accessoryIconId: string;

  /**
   * *
   * Additional accessory text on the instrument in Linked Banks, e.g. "Default Payment Method"
   *
   * @generated from field: optional string accessory_text = 28;
   */
  accessoryText: string;

  /**
   * @generated from field: optional squareup.cash.localization.LocalizableString localizable_accessory_text = 32;
   */
  localizableAccessoryText?: LocalizableString;

  /**
   * *
   * Compact display name for the instrument selector ui component in Add Money and Withdraw
   *
   * @generated from field: optional string display_name_compact = 29;
   */
  displayNameCompact: string;

  /**
   * @generated from field: optional squareup.cash.localization.LocalizableString localizable_display_name_compact = 33;
   */
  localizableDisplayNameCompact?: LocalizableString;

  /**
   * *
   * Whether this is the default instrument of this type for the user
   *
   * @generated from field: optional bool is_default_for_instrument_type = 30;
   */
  isDefaultForInstrumentType: boolean;

  /**
   * *
   * The URL to an image of the digital representation of the card (e.g., for digital wallets).
   * This is the full card art/design image, distinct from icon URLs which are bank/network logos.
   * Only populated for card instruments. 
   *
   * @generated from field: optional string card_art_url = 31;
   */
  cardArtUrl: string;
};

/**
 * Describes the message squareup.franklin.api.Instrument.
 * Use `create(InstrumentSchema)` to create a new message.
 */
export const InstrumentSchema: GenMessage<Instrument> = /*@__PURE__*/
  messageDesc(file_squareup_franklin_api_instrument, 0);

